import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@99designs/emu';
import { Icon } from '@99designs/frontend-components/components/Icon';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { CurrencyCode } from '@99designs/i18n';
// FIXME: https://gitlab.com/vistaprint-org/99designs/frontend/-/issues/3322
// eslint-disable-next-line no-restricted-imports
import { Price } from '@99designs/spa-common';

const TooltipContent = styled.div`
    max-width: 360px;
`;

const HelpIcon = styled.span`
    cursor: pointer;
    display: inline-block;
`;

function PriceGuide({ min, max, currency }: { min: number; max?: number; currency: CurrencyCode }) {
    const formattedPrices = () => {
        const formattedMin = <Price amount={min} currency={currency} />;

        if (!max) {
            return (
                <FormattedMessage message={__('from {amount}')} values={{ amount: formattedMin }} />
            );
        }

        return (
            <>
                <Price amount={min} currency={currency} />
                {' – '}
                <Price amount={max} currency={currency} />
            </>
        );
    };

    return (
        <div data-testid="price-guide">
            {__('Price guide:')} {formattedPrices()}
            <Tooltip
                placement="top-start"
                title={
                    <TooltipContent>
                        {__(
                            'Based on the prices that designers typically quote for projects in this category.'
                        )}
                    </TooltipContent>
                }
            >
                <HelpIcon>
                    <Icon type={'question-mark-1'} variations={['offset-left']} />
                </HelpIcon>
            </Tooltip>
        </div>
    );
}

export default PriceGuide;
export { PriceGuide };
